// Angular
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
// Fuse
import { FuseConfigService } from '@fuse/services/config.service';
import { environment } from 'environments/environment';
import { fuseAnimations } from '@fuse/animations';
// Translate
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { locale as english } from '../i18n/en';
import { locale as spanish } from '../i18n/es';
// Loader
import { NgxUiLoaderService } from 'ngx-ui-loader';
// Material
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
// Local services
import { EmployeeService } from '../../../employee.service';
import { ToastService } from '@fuse/utils/toast.service';
// Constants
import { Constants } from '../../../../../../@fuse/utils/constants';

@Component({
  selector: 'employee-table-discounts',
  templateUrl: './table-discounts.component.html',
  styleUrls: ['./table-discounts.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class TableDiscountsComponent implements OnInit, AfterViewInit {
// data
  @Input()
  complexId = '';
  searchString = '';
  employeeId = '';
  // Data bindings
  data = [];
  dataSource = new MatTableDataSource();
  displayedColumns = [
    'id',
    'name',
    'description',
    'amount',
  ];
// Pagination
  pageNumber = 1;
  itemsPerPage = 10;
  totalItems = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // Sort
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private activatedRoute: ActivatedRoute,
    private employeeService: EmployeeService,
    private fuseConfigService: FuseConfigService,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private loader: NgxUiLoaderService,
    private router: Router,
    private toast: ToastService,
    private translate: TranslateService,
  ) {
    this.fuseTranslationLoaderService.loadTranslations(english, spanish);
    this.translate.use(environment.DEFAULT_LANG);
  }

  ngOnInit(): void {
    this.employeeId = this.activatedRoute.snapshot.paramMap.get('employeeId');
    const lang = localStorage.getItem('lang');
    if (lang !== undefined && lang !== '' && lang !== null) {
      this.translate.use(lang);
    } else {
      this.translate.use(this.translate.currentLang);
    }
    this.getEmployeeInfo();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  changePage(event: any): void {
    this.pageNumber = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.getEmployeeInfo();
  }

  getEmployeeInfo(): void {
    this.loader.start();
    this.employeeService.getEmployee(
      this.employeeId, {
        lang: this.translate.currentLang,
      }).subscribe(
      result => {
        if (result.success === true) {
          this.data = result.data.salary.discounts;
          this.dataSource = new MatTableDataSource(result.data.salary.discounts);
          this.dataSource.sort = this.sort;
          this.totalItems = +result.data.totalItems;
          this.loader.stop();
        } else {
          this.toast.showToast(
            Constants.TOAST_TYPE_ERROR,
            this.translate.instant('MESSAGES.' + result.message),
          );
          this.loader.stop();
        }
      }, () => {
        this.router.navigate(['/pages/error/']);
        this.loader.stop();
      }
    );
  }

}
